import React from "react";
import { TimeValue } from "react-aria";
import { TimeFieldStateOptions } from "react-stately";
import { TimeField } from "./TimeField";

export type TimePickerProps = Omit<
  TimeFieldStateOptions<TimeValue>,
  "locale"
> & {
  className?: string;
  hasError?: boolean;
  disabled?: boolean;
};

const TimePicker = React.forwardRef<HTMLDivElement, TimePickerProps>(
  (props, forwardedRef) => {
    return (
      <TimeField {...props} aria-label="Heure" isDisabled={props.disabled} />
    );
  }
);

TimePicker.displayName = "TimePicker";

export { TimePicker };
